import {createStateContext} from 'react-use';
import {sessionOfficerIdKey, sessionOfficerNameKey} from './utils/constants';

export type AccountExecutiveContextState = {
  value: string | undefined;
  name: string | undefined;
};

const initialState: AccountExecutiveContextState = {
  value: localStorage.getItem(sessionOfficerIdKey) ?? undefined,
  name: localStorage.getItem(sessionOfficerNameKey) ?? undefined,
}

export const [useAccountExecutiveContext, AccountExecutiveContextProvider] =
  createStateContext<AccountExecutiveContextState>(initialState);